import http from './http'

/**
 * 获取号码生肖映射表
 * GET /api/meta/zodiac → { code: 200, data: { cycle: {...}, map: { "1":"马", "2":"蛇", ... } } }
 */
export function fetchZodiacMap() {
  return http.get('/api/meta/zodiac')
}
